import { AppData } from './types';

export const initialState: AppData = {
  id: '',
  tenant: {},
  email: '',
  firstName: '',
  lastName: '',
  primaryRole: 'office',
  roles: [],
  isLogged: false,
  isResolvingAuth: false,
  apiActivity: true,
  onDeckError: false,
  hotSeatError: false,
  isTutorial: false,
  isDropdownEnabled: false,
  menuAccess: [],
  homePage: '',
  displayOptionsSettings: [],
  displayOptions: [],
  admin: {
    isLogged: false,
    data: {},
  },
};
